import { render, staticRenderFns } from "./ModalSendCaseToOrg.vue?vue&type=template&id=7ddc7990&scoped=true"
import script from "./ModalSendCaseToOrg.vue?vue&type=script&lang=js"
export * from "./ModalSendCaseToOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc7990",
  null
  
)

export default component.exports